function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    text\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.91,12.94H6.24V10H21.05v2.93H15.38V29.63H11.91Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.09,24.66v-7H22V15.05l2.28-.16.41-4h2.87v4H31.3v2.75H27.55v7c0,1.73.67,2.58,2.08,2.58a4.8,4.8,0,0,0,1.54-.33l.59,2.54a9.71,9.71,0,0,1-3,.54C25.35,30,24.09,27.84,24.09,24.66Z",
  fill: "#231f20"
});

function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3);
}

export default SvgText;